module.exports = __webpack_public_path__ + "static/media/indian.fcb35b1c.jpg";